/* eslint-disable react-hooks/exhaustive-deps */
import Shortcode from 'src/libs/useful/shortcode'
import IScalarForm from '../interface/IScalarForm'
import Scalar from './Scalar'
import {CodeEditor} from "src/libs/useful"
import { useEffect, useState } from 'react'

const HTML = ( props: IScalarForm ): JSX.Element => {
    return <Scalar 
        { ...props } 
        enabledForm={<HTMLEnabled {...props} />}
        desabledForm={<HTMLDisabled {...props} />}
    /> 
}  

export default HTML

export const HTMLEnabled = (props: IScalarForm) : JSX.Element =>  {
    const [ value, setValue ] = useState<string>( props.value || props.default || "" )
    useEffect(() => {
        setValue( props.value || props.default || "" )
    }, [props.value])
    const onChange = (fileData: string ) => {
        if( props.onChange) props.onChange( fileData, props.field, "" )
    }
    return <div className={`d-flex w-100 align-items-start ${props.className ? props.className : ""}`}> 
        <div className=" pe-code-editor my-2 ml-3">
            <CodeEditor
                value={ value?.toString().replaceAll( "<!-- /wp:paragraph -->", "" ) || "" }
                onChange={ onChange }
                autoFocus={!!props.autoFocus}
                placeholder={props.placeholder}
                className={props.elementClassName}
                rows={props.rows}
            />
        </div>
    </div>
}

export const HTMLDisabled = (props: IScalarForm) : JSX.Element => {
    const [value ] = useState<string>(props.value || props.default || "")
    return <Shortcode content={ value?.toString().replaceAll("<!-- wp:paragraph -->", "")} className={props.elementClassName} />
}